export { default } from "./Modal";
//# sourceMappingURL=index.js.map